module.exports = __webpack_public_path__ + "img/maintain.b5013579.png";